import ToastHighLighter from '@/lib/ToastHighLighter';

export const OffCanvasCode = () => {
  const language = 'html';
  const codeString = `
  // Offcanvas
  <a
    class="btn btn-primary"
    data-bs-toggle="offcanvas"
    href="#offcanvasExample"
    role="button"
    aria-controls="offcanvasExample"
  >
    Link with href
  </a>
  <button
    class="btn btn-primary"
    type="button"
    data-bs-toggle="offcanvas"
    data-bs-target="#offcanvasExample"
    aria-controls="offcanvasExample"
  >
    Button with data-bs-target
  </button>

  <div
    class="offcanvas offcanvas-end"
    tabIndex="-1"
    id="offcanvasExample"
    aria-labelledby="offcanvasExampleLabel"
  >
    <div class="offcanvas-header">
      <h5 class="offcanvas-title" id="offcanvasExampleLabel">
        Offcanvas
      </h5>
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      ></button>
    </div>
    <div class="offcanvas-body">
      <div>
        Some text as placeholder. In real life you can have the elements you
        have chosen. Like, text, images, lists, etc.
      </div>
    </div>
  </div>
  `;

  return (
    <>
      <ToastHighLighter
        name={'offcanvas'}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};
